var _circle, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _circle2, _rect3, _rect4, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffEmptyIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 60,
    fill: "#F2F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9277 36.2803C15.9277 34.2313 17.5888 32.5703 19.6378 32.5703H101.361C103.41 32.5703 105.071 34.2313 105.071 36.2803V86.2889C105.071 88.3378 103.41 89.9989 101.361 89.9989H19.6378C17.5888 89.9989 15.9277 88.3378 15.9277 86.2889V36.2803Z",
    fill: "url(#paint0_linear_1857_164180)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.9355,
    y: 33.2871,
    width: 6.43299,
    height: 20.5856,
    rx: 3.21649,
    transform: "rotate(90 43.9355 33.2871)",
    fill: "url(#paint1_linear_1857_164180)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 97.7578,
    y: 33.2871,
    width: 6.43299,
    height: 20.5856,
    rx: 3.21649,
    transform: "rotate(90 97.7578 33.2871)",
    fill: "url(#paint2_linear_1857_164180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5219 65.4141V70.2251L57.0703 70.2251L57.0703 65.4141L79.5219 65.4141Z",
    fill: "url(#paint3_linear_1857_164180)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4674 49.7129V54.524L57.1816 54.524L57.1816 49.7129L97.4674 49.7129Z",
    fill: "url(#paint4_linear_1857_164180)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9707 24.4292C25.9707 23.7186 26.5467 23.1426 27.2573 23.1426H40.2662C40.9768 23.1426 41.5528 23.7186 41.5528 24.4292V35.9541C41.5528 36.6646 40.9768 37.2407 40.2662 37.2407H27.2573C26.5467 37.2407 25.9707 36.6646 25.9707 35.9541V24.4292Z",
    fill: "url(#paint5_linear_1857_164180)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7461 24.4292C79.7461 23.7186 80.3221 23.1426 81.0327 23.1426H93.8987C94.6092 23.1426 95.1853 23.7186 95.1853 24.4292V35.8594C95.1853 36.57 94.6092 37.146 93.8987 37.146H81.0327C80.3221 37.146 79.7461 36.57 79.7461 35.8594V24.4292Z",
    fill: "url(#paint6_linear_1857_164180)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.4994,
    cy: 94.2943,
    r: 12.8295,
    fill: "url(#paint7_linear_1857_164180)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.8945,
    y: 87.8789,
    width: 3.20737,
    height: 12.8295,
    fill: "#3EE78D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.9141,
    y: 92.6895,
    width: 3.20737,
    height: 12.8295,
    transform: "rotate(90 66.9141 92.6895)",
    fill: "#3EE78D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7852 58.7611C38.4671 58.7611 41.4518 55.776 41.4518 52.0944C41.4518 48.4128 38.4671 45.4277 34.7852 45.4277C31.1033 45.4277 28.1185 48.4128 28.1185 52.0944C28.1185 55.776 31.1033 58.7611 34.7852 58.7611Z",
    fill: "url(#paint8_linear_1857_164180)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4518 61.4277C26.6654 61.4277 22.7852 65.3079 22.7852 70.0944V74.7611H46.7852V70.0944C46.7852 65.3079 42.905 61.4277 38.1185 61.4277L34.7852 64.7611L31.4518 61.4277Z",
    fill: "url(#paint9_linear_1857_164180)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6797 15.502L41.6797 10.2856",
    stroke: "#6CCC93",
    strokeWidth: 1.71429,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0723 12.8945L44.2886 12.8945",
    stroke: "#6CCC93",
    strokeWidth: 1.71429,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1074 20.6484L75.1074 15.4321",
    stroke: "#6CCC93",
    strokeWidth: 1.71429,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 18.0391L77.7164 18.0391",
    stroke: "#6CCC93",
    strokeWidth: 1.71429,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.25 104.648L92.25 99.4321",
    stroke: "#6CCC93",
    strokeWidth: 1.71429,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6426 102.039L94.8589 102.039",
    stroke: "#6CCC93",
    strokeWidth: 1.71429,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1857_164180",
    x1: 63.3589,
    y1: 90.3076,
    x2: 63.3589,
    y2: 41.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1857_164180",
    x1: 42.5848,
    y1: 36.6236,
    x2: 48.8474,
    y2: 36.6236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1857_164180",
    x1: 96.407,
    y1: 36.6236,
    x2: 102.67,
    y2: 36.6236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1857_164180",
    x1: 52.356,
    y1: 66.1938,
    x2: 74.2132,
    y2: 66.1938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1857_164180",
    x1: 48.7226,
    y1: 50.4927,
    x2: 87.9417,
    y2: 50.4927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B206F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1857_164180",
    x1: 34.2616,
    y1: 37.3164,
    x2: 34.2616,
    y2: 25.4276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1857_164180",
    x1: 87.961,
    y1: 37.2213,
    x2: 87.961,
    y2: 25.4122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1857_164180",
    x1: 61.3226,
    y1: 107.262,
    x2: 61.3226,
    y2: 85.6236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C2894"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#4766DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1857_164180",
    x1: 35.5551,
    y1: 81.4844,
    x2: 35.5551,
    y2: 50.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1857_164180",
    x1: 35.5551,
    y1: 81.4844,
    x2: 35.5551,
    y2: 50.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#112367"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94793,
    stopColor: "#213DA9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffEmptyIc);
export default __webpack_public_path__ + "static/media/staff-empty-ic.6a872b29369f55cc1607c4153e93eeaa.svg";
export { ForwardRef as ReactComponent };